import { IonCol, IonContent, IonGrid, IonHeader, IonPage, IonRow } from "@ionic/react";
import { FileTemplateCreateForm } from "./components/FileTemplateCreateForm";
import { Toolbar } from "./components/Toolbar";

export const FileTemplateCreate: React.FC = () => {
  
  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <Toolbar />
      </IonHeader>
      <IonContent fullscreen>
        <IonGrid>
          <IonRow>
            <IonCol>
              <FileTemplateCreateForm />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
